import { useState } from 'react';

import { LayoutRectangle } from 'react-native';

import { SharedValue, runOnJS, useDerivedValue } from 'react-native-reanimated';

const SCROLL_CORRECTION = 10;

export const useIsInbound = (
    rect: LayoutRectangle,
    xStartOffset?: SharedValue<number>,
    xEndOffset?: SharedValue<number>,
    yStartOffset?: SharedValue<number>,
    yEndOffset?: SharedValue<number>,
) => {
    const [inbound, setIsInbound] = useState(true);

    useDerivedValue(() => {
        const startX = rect.x - SCROLL_CORRECTION;
        const endX = rect.x + rect.width + SCROLL_CORRECTION;
        const startY = rect.y - SCROLL_CORRECTION;
        const endY = rect.y + rect.height + SCROLL_CORRECTION;

        let inboundX = true;
        if (xStartOffset && xEndOffset) {
            inboundX = !(
                xStartOffset.value > endX || xEndOffset.value < startX
            );
        }

        let inboundY = true;
        if (yStartOffset && yEndOffset) {
            inboundY = !(
                yStartOffset.value > endY || yEndOffset.value < startY
            );
        }

        runOnJS(setIsInbound)(inboundX && inboundY);
    }, [rect]);

    return inbound;
};
